import { takeLatest, put, call } from 'redux-saga/effects';

import { findProcedimentoCadastro } from '../service';
import {
  FIND_PROCEDIMENTO_CADASTRO,
  FIND_PROCEDIMENTO_CADASTRO_PENDING,
  FIND_PROCEDIMENTO_CADASTRO_SUCCESS,
  FIND_PROCEDIMENTO_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaFindProcedimentoCadastro(action) {
  yield put({ type: FIND_PROCEDIMENTO_CADASTRO_PENDING, id: action.id })

  try {

    const registro = yield call(findProcedimentoCadastro, action.id);

    yield put({ type: FIND_PROCEDIMENTO_CADASTRO_SUCCESS, registro: registro })

  } catch (error) {

    yield put({ type: FIND_PROCEDIMENTO_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchFindProcedimentoCadastro() {
  yield takeLatest(FIND_PROCEDIMENTO_CADASTRO, sagaFindProcedimentoCadastro)
}
